import './Header.scss';
import React from 'react';
import Search from '../search/Search';
import MenuContainer from '../menuContainer/MenuContainer';

export const Header = () => {
    return (
      <div className="b-header">
        <MenuContainer />
        <Search />
      </div>
    )
}

export default Header;
